import { useEffect, useRef, useState } from "react";
import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/Footer/Footer";
import "./stripe.css";
import { useNavigate } from "react-router-dom";

//icons
import checkIcon from "../../assets/images/greenCheck.png";
import errorIcon from "../../assets/images/error.png";
import { ConfirmationModal } from "../../components/Modals/ConfirmationModal/confirmation-modal";
import { isMobileDevice } from "../../utils/genericUtils";
import { AcknowledgementModal } from "../../components/Modals/AcknowledgementModal/acknowledgement-modal";

const defaultProps = {
  success: true,
};

export function StripeResultPage(props = defaultProps) {
  const router = useNavigate();
  const selectedPlan = useRef(0);

  const [isStripeRegisterFlow, setIsStripeRegisterFlow] = useState(sessionStorage.getItem("stripe-register-flow") === "true");

  useEffect(() => {
    // Parse the query string using URLSearchParams
    let params = new URLSearchParams(window.location.search);

    selectedPlan.current = parseInt(params.get("plan") ?? 0);
  }, []);

  function SetupMFA() {
    router("/mfa-setup");
  }

  function Dashboard() {
    sessionStorage.removeItem("stripe-register-flow");
    router("/dashboard");
  }

  function RenderModal() {
    if (props.success) {
      if (isStripeRegisterFlow) {
        return (
          <ConfirmationModal
            id="stripe-success"
            icon={checkIcon}
            showDivider={true}
            header="Thank You for Your Payment!"
            message={
              "Your upgrade was successful! For added security, would you like to enable Multi-Factor Authentication now? You can also do this later from your account settings."
            }
            isActive={true}
            animate={false}
            confirmText={"Setup MFA"}
            denyText={"Setup Later"}
            onConfirm={SetupMFA}
            onDeny={Dashboard}
            confirmClass="btn-green"
          />
        );
      } else {
        return (
          <AcknowledgementModal
            id="change-stripe-subscription-success-modal"
            icon={checkIcon}
            showDivider={true}
            header="Thank You!"
            message={"Your Subscription details were updated successfully!"}
            isActive={true}
            animate={false}
            onAcknowledge={Dashboard}
            buttonText={"Head To My Dashboard"}
          />
        );
      }
    } else {
      return (
        <ConfirmationModal
          id="stripe-fail"
          icon={errorIcon}
          showDivider={true}
          header="We Couldn't Process Your Payment"
          message={`No worries — you can try again anytime from your account settings.
             Would you like to enable Multi-Factor Authentication now for extra security? This can also be done later.`}
          isActive={true}
          animate={false}
          confirmText={"Setup MFA"}
          denyText={"Setup Later"}
          onConfirm={SetupMFA}
          onDeny={Dashboard}
          confirmClass="btn-green"
        />
      );
    }
  }

  return (
    <>
      <section className="thanks-page-bg">
        <Navbar />
        {RenderModal()}
        {!isMobileDevice() && <Footer />}
      </section>
    </>
  );
}
